import React from 'react';
import { Outlet } from 'react-router-dom';

function WithdrawalScene() {
  return <Outlet />;
}

export default WithdrawalScene;
